import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsTimelineRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-timeline',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
	exact: true,
};
